module.exports = __webpack_public_path__ + "img/button-red.233b34fd.png";